import { colors } from '../../colors';
var para = {
  messageColor: colors.pine
};
export default para;